import { useLayoutEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import baseTheme from "../../../../core/theme";
import {
  collectionFfveThemeOptions,
  mountCollectionFfveAppearance,
} from "../../branding/collection-ffve/collection-ffve";
import "../../branding/collection-ffve/collection-ffve.css";

const collectionFfveTheme = createTheme(baseTheme, collectionFfveThemeOptions);

export default function CollectionFfveAppearance({ active, children }) {
  useLayoutEffect(() => {
    if (active) return mountCollectionFfveAppearance(document.body);
  }, [active]);

  return (
    <ThemeProvider theme={active ? collectionFfveTheme : baseTheme}>
      {children}
    </ThemeProvider>
  );
}
